import { useQuery } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

/**
 * One member's application.
 *
 * `application` is null when there is nothing to show — a member who never
 * applied, which the service maps from a 404 — so callers have to tell that
 * apart from `isError`, the same two-outcome contract useCycle carries. Only
 * the dialog mounts this hook, so the read happens when an admin asks for it
 * rather than once per roster row.
 */
export const useMemberApplication = (cycleId, userId) => {
  const { data, isPending, isError } = useQuery({
    queryKey: awardsKeys.memberApplication(cycleId, userId),
    queryFn: () => AwardsService.getMemberApplication(cycleId, userId),
    enabled: Boolean(cycleId && userId),
    retry: false,
  });

  return { application: data ?? null, isPending, isError };
};
